import { fetchScenario, getInitPlayerOptions, store } from '@libs/core';
import { redirect } from 'react-router';
import { AccessDeniedScreen, checkAccess } from './access';

export const ACCESS_DENIED_PATH = '/fill-in';

/**
 * Loader for the root '/' route (the player App).
 *
 * First performs the synchronous access check. On a failed check — when the active
 * package (NX_PUBLIC_PACKAGE_NAME) provides an AccessDeniedScreen — it redirects to
 * ACCESS_DENIED_PATH and does NOT call fetchScenario. On success (or when the package
 * ships no AccessDeniedScreen) it dispatches fetchScenario and lets the App mount.
 */
export const rootLoader = () => {
    const passed = checkAccess?.() ?? true;

    if (!passed && AccessDeniedScreen) {
        return redirect(ACCESS_DENIED_PATH);
    }

    if (navigator?.onLine) {
        store.dispatch(
            fetchScenario({
                action: undefined,
                widgetUid: undefined,
                isShowLoader: true,
                initPayerOptions: getInitPlayerOptions(),
            }),
        );
    }

    return null;
};

/**
 * Loader for the access-denied route. Sends the user back to '/' when access is
 * (now) granted or the active package ships no AccessDeniedScreen — so the screen
 * is never reachable when there is nothing to show or nothing to gate.
 */
export const accessDeniedLoader = () => {
    const passed = checkAccess?.() ?? true;

    if (passed || !AccessDeniedScreen) {
        return redirect('/');
    }

    return null;
};
